import { SORT_COLUMN, UPDATE_DATA } from "./types";

export const sortColumn = (data, orderBy, order) => {
  return {
    type: SORT_COLUMN,
    payload: { data, orderBy, order }
  };
};

export const updateData = data => {
  return {
    type: UPDATE_DATA,
    payload: data
  };
};



// WEBPACK FOOTER //
// ./src/actions/table_actions.js